module.exports = __webpack_public_path__ + "media/images/dtfa-wwk-horizontal-logo-rgb-071a50331b4ce6b8df6dcbf3fb5c2def.jpg";